import React, { useEffect } from "react";
import StatsCounter from "../Common/StatsCounter";
import AboutSection from "../Common/AboutSection";
import TeamSection from "../Common/TeamSection";
import { statsData } from "../../data/statsData";

function About() {

   const aboutData = {
    subtitle: "About Us",
    title: "About Unigenius",
    description1:
      "Unigenius is a leading UK university education consultancy dedicated to helping students turn their study-abroad ambitions into reality. We specialize in UK university admissions guidance, providing expert, end-to-end support to students who aspire to study at top universities across the United Kingdom.",
    description2:
      "Pellentesque aliquam dolor eget urna ultricies tincidunt. Nam volutpat libero sit amet leo cursus, ac viverra eros tristique. Morbi quis quam mi. Cras vel gravida eros. Proin scelerisque quam nec elementum viverra.",
    buttonText: "More Details",
    buttonLink: "/about",
    image1: "https://themewagon.github.io/HighTechIT/img/about-1.jpg",
    image2: "https://themewagon.github.io/HighTechIT/img/about-2.jpg",
  };

    useEffect(() => {
      window.scrollTo(0, 0);
    }, {});

  return (

<div className="about">

    <div class="container-fluid page-header py-5">
            <div class="container text-center py-5">
                <h1 class="display-2 text-white mb-4 animated slideInDown">About Us</h1>
                <nav aria-label="breadcrumb animated slideInDown">
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="breadcrumb-item"><a href="/">Pages</a></li>
                        <li class="breadcrumb-item" aria-current="page">About</li>
                    </ol>
                </nav>
            </div>
        </div>

        <StatsCounter stats={statsData} />
        <AboutSection {...aboutData} />

        {/* <TeamSection title="Meet Our Expert Team" subtitle="Our Team" /> */}
        
</div>
    
 );
}

export default About;  